module.exports = __webpack_public_path__ + "img/1519835706.9cf051ac.jpg";